import * as types from "@/constants"
import api from "@/api"
import { webserverURL } from "@/utils/getWebserver"

export default {
  state: {
    webserverURL,
    webseverData: {
      data: {},
      status: ""
    }
  },
  actions: {
    async fetchWebserverData({ dispatch, commit, rootState }) {
      commit(types.FETCH_WEBSERVER_DATA)
      let { webserverURL } = rootState.webserverInfo
      try {
        commit(
          types.FETCH_WEBSERVER_DATA_SUCCESSED,
          await api.fetchWebserverData(webserverURL)
        )
      } catch (error) {
        return Promise.reject(error)
      }
    }
  },
  mutations: {
    FETCH_WEBSERVER_DATA(state, payload) {
      state.webseverData = Object.assign({}, state.webseverData, {
        data: {},
        status: types.FETCH
      })
    },
    FETCH_WEBSERVER_DATA_SUCCESSED(state, payload) {
      state.webseverData = Object.assign({}, state.webseverData, {
        data: { ...payload },
        status: types.FETCH_SUCCESSED
      })
    },
    FETCH_WEBSERVER_DATA_FAILED(state, payload) {
      state.webseverData = Object.assign({}, state.webseverData, {
        data: null,
        status: types.FETCH_FAILED
      })
    }
  },
  getters: {
    webseverData: state => state.webseverData
  }
}
